import { qs, toggle } from "@fluorescent/dom";

const selectors = {
  counterContainer: "[data-inventory-counter]",
  inventoryMessage: ".inventory-counter__message-text",
  inventoryTransferMessage: ".inventory-counter__transfer-notice",
  progressBar: ".inventory-counter__bar-progress",
};

const classes = {
  hidden: "hidden",
};

// Applies the inventory-counter state from a rendered section response
// (`source`) to the live counter in `container`. Mutates attributes and text
// on the existing elements rather than swapping innerHTML so the CSS-driven
// reveal animation (bar slide, color fade) fires the same way it does on hard
// load.
//
// The state is always read from the liquid-resolved `data-current-*`
// attributes, which are computed per-request from `current_variant` — so it is
// correct for any variant regardless of position. On initial load `source` is
// the container itself (apply the liquid-rendered state to its own visible
// elements); on a variant change `source` is the freshly fetched section.
export function updateInventoryCounterFromHTML(container, source) {
  const oldEl = qs(selectors.counterContainer, container);
  const newEl = qs(selectors.counterContainer, source);
  if (!oldEl || !newEl) return;

  const {
    currentStockCategory,
    currentInventoryMessage,
    currentTransferMessage,
    currentBarPercent,
    currentInventoryValid,
  } = newEl.dataset;

  toggle(oldEl, classes.hidden, currentInventoryValid !== "true");

  if (currentStockCategory) {
    oldEl.setAttribute("data-stock-category", currentStockCategory);
  } else {
    oldEl.removeAttribute("data-stock-category");
  }

  const messageEl = qs(selectors.inventoryMessage, oldEl);
  if (messageEl) messageEl.textContent = currentInventoryMessage || "";

  const transferEl = qs(selectors.inventoryTransferMessage, oldEl);
  if (transferEl) transferEl.textContent = currentTransferMessage || "";

  const barEl = qs(selectors.progressBar, oldEl);
  if (barEl) barEl.style.width = `${currentBarPercent || 0}%`;
}
